// This file contains utility functions for the web application.
import { Popover, Tooltip } from "bootstrap";
export class TimeoutError extends Error {
    constructor(message) {
        super(message);
        this.name = "TimeoutError";
    }
}
// Utility function to asynchronously wait for a specified number of milliseconds
export function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
// Utility function that throws a TimeoutError after a specified number of milliseconds if the otherPromise does not resolve
export function timeout(otherPromise, ms) {
    return new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => {
            const errorString = `Operation timed out after ${ms} milliseconds`;
            console.error(errorString);
            reject(new TimeoutError(errorString));
        }, ms);
        otherPromise
            .then((result) => {
            clearTimeout(timeoutId);
            resolve(result);
        })
            .catch((error) => {
            clearTimeout(timeoutId);
            reject(error);
        });
    });
}
export function initializePopovers() {
    // Initialize all popovers
    const popoverTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="popover"]'));
    [...popoverTriggerList].map((popoverTriggerEl) => new Popover(popoverTriggerEl));
    // Initialize all tooltips
    const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    [...tooltipTriggerList].map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));
}
export async function showFadedOutContainer(container) {
    // Ensure fade-out class is applied first (to set opacity to 0)
    container.classList.add("fade-out");
    // Force a reflow to ensure the browser registers the opacity change
    container.offsetWidth;
    // Wait for a short delay to allow the fade-out animation to complete
    await delay(400);
    // Then remove it to trigger the transition
    container.classList.remove("fade-out");
}
Document.prototype.getHtmlElementById = function getHtmlElementById(id) {
    const element = document.getElementById(id);
    if (!element) {
        return null;
    }
    return element;
};
Document.prototype.getRequiredHtmlElementById = function getRequiredHtmlElementById(id) {
    const element = this.getHtmlElementById(id);
    if (!element) {
        throw new Error(`Element of with ID "${id}" not found`);
    }
    return element;
};
Document.prototype.queryHtmlElements = function queryHtmlElements(selector) {
    const elements = document.querySelectorAll(selector);
    return elements ? Array.from(elements) : [];
};
Document.prototype.whenHtmlElementExists = function whenHtmlElementExists(...args) {
    // The last argument must be the function
    const func = args[args.length - 1];
    const ids = args.slice(0, -1);
    if (typeof func !== "function" || !ids.every((id) => typeof id === "string")) {
        throw new Error("Invalid arguments: expected (id1: string, ..., func: function)");
    }
    // Get all elements by their IDs
    const elements = ids.map((id) => this.getHtmlElementById(id));
    if (elements.every(Boolean)) {
        // TypeScript: elements is (HTMLElement|null)[], but we know they're not null here
        return func(...elements);
    }
};
Element.prototype.queryHtmlElements = function queryHtmlElements(selector) {
    const elements = this.querySelectorAll(selector);
    return elements ? Array.from(elements) : [];
};
Element.prototype.queryHtmlElement = function queryHtmlElement(selector) {
    const element = this.querySelector(selector);
    return element ? element : null;
};
Element.prototype.whenQueriedHtmlElementExists = async function whenQueriedHtmlElementExists(selector, func) {
    const element = this.queryHtmlElement(selector);
    if (element) {
        return func(element);
    }
};
Element.prototype.bootstrapHide = function bootstrapHide() {
    this.classList.add("d-none");
};
Element.prototype.bootstrapShow = function bootstrapShow() {
    this.classList.remove("d-none");
};
Element.prototype.isBootstrapVisible = function isBootstrapVisible() {
    return !this.classList.contains("d-none");
};
